import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { DeletionImpactResponse, DriverDeletionImpactItem, TruckDeletionImpactItem } from 'src/entities/deletionImpact.entity';

export const useTruckDeletionImpact = () => useMutation(async (ids: number[]) => {
  const res = await axios.post<DeletionImpactResponse<TruckDeletionImpactItem>>('/api/v2/trucks/deletion_impact', { ids });
  return res.data;
});

export const useDriverDeletionImpact = () => useMutation(async (ids: number[]) => {
  const res = await axios.post<DeletionImpactResponse<DriverDeletionImpactItem>>('/api/v2/drivers/deletion_impact', { ids });
  return res.data;
});
